<script setup>
import { BLink, vBTooltip } from 'bootstrap-vue-next';

import FaQuestionCircleO from '~icons/fa/question-circle-o';

defineProps({
  hash: {
    type: String,
    default: '#contributor-levels',
  },
  tooltip: {
    type: String,
    default: 'Points, scoring, and contributor level documentation',
  },
  large: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <BLink
    v-b-tooltip="tooltip"
    :to="{ name: 'documentation', params: { page: 'user-guide' }, hash }"
    class="ms-2 text-secondary"
  >
    <FaQuestionCircleO :class="large ? 'question-circle-icon--large' : 'question-circle-icon'" />
  </BLink>
</template>
